import { utils, getXPath } from '@alife/cone-arms-core';
import { ITrace } from './types';
import traceSdk from './sdk';
import { getEnv } from './utils';

const { bindEvent, checkWin } = utils;

const defaultCatchErrorPid = 'cn_cone_arms_global_pre_catch_error';

let stopWatchError: () => void;

export const startCatchPreError = () => {
  if (checkWin()) {
    stopWatchError = bindEvent(
      window,
      'error',
      (e: ErrorEvent) => {
        if (e) {
          window._coneArmsPreCollectErrors = window._coneArmsPreCollectErrors || [];
          window._coneArmsPreCollectErrors.push(e);
        }
      },
      false,
      true,
    );
    setTimeout(() => {
      const trace = traceSdk({
        // 默认不上报错误，避免重复初始化错误插件，多一次监听error事件
        errorEnable: false,
        useSendBeacon: true,
        singleton: false,
        pid: defaultCatchErrorPid,
        env: getEnv(),
      });
      if (trace) {
        // 开启错误上报，让trace实例可以上报前面收集的错误
        trace.setConfig({
          errorEnable: true,
        });
        doErrorReportAndStopWatchPreError(trace as ITrace);
      }
    }, 10000);
  }
};

export const doErrorReportAndStopWatchPreError = (trace: ITrace) => {
  if (typeof stopWatchError === 'function') {
    stopWatchError();
  }
  if (
    checkWin() &&
    window._coneArmsPreCollectErrors &&
    window._coneArmsPreCollectErrors.length > 0
  ) {
    window._coneArmsPreCollectErrors.forEach((e) => {
      const target = e.target as HTMLElement;
      if (!(!target?.tagName || e.message || e.filename || e.lineno || e.colno)) {
        if (target) {
          const targetTagName = target.tagName.toLowerCase();
          const src = (target as HTMLScriptElement).src || (target as HTMLLinkElement).href;
          if (['img', 'script', 'link'].indexOf(targetTagName) > -1 && src) {
            trace.log({
              type: 'resource_error',
              msg: ''.concat(src, ' 资源报错'),
              p1: targetTagName,
              p2: getXPath(target, 5),
            });
          }
        }
      } else if (trace.getConfig().errorEnable) {
        trace.logError(e);
      }
    });

    // 当不是默认公共上报实例的pid时，清空前面收集的错误，避免重复上报
    if (trace.getConfig().pid !== defaultCatchErrorPid) {
      window._coneArmsPreCollectErrors = [];
    }
  }
};
